import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#004898', // A
          'primary-darken1': '#264569', // R
          'primary-lighten1': '#d9ebff', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#009fa8', // B
          'secondary-darken1': '#376d70', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#FFFFFF', // E
          headerText: '#004898', // F
          logoutBtnText: '#004898', // G
          topSchoolNamePc: '#004898', // H
          topSecondaryBtn: '#009fa8', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#004898', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#004898', // N
          secondaryOutLineBtnText: '#009fa8', // O
          topBtnUpTextSp: '#004898', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#E7EFFF',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#004898',
          accent: '#004898', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
